import { AlertCircle } from 'lucide-react';

interface TriageEmptyStateProps {
  title?: string;
  description?: string;
}

export function TriageEmptyState({
  title = 'No threads found',
  description = 'Try adjusting your filters or connect email accounts to ingest emails.',
}: TriageEmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center bg-card/20 rounded-xl border border-dashed border-border/50">
      <AlertCircle className="h-12 w-12 text-muted-foreground mb-4 opacity-20" />
      <h3 className="font-semibold text-lg">{title}</h3>
      <p className="text-sm text-muted-foreground mt-1 max-w-xs">{description}</p>
    </div>
  );
}
